module.exports = __webpack_public_path__ + "img/second-prize.88f77f0.png";